<mat-form-field class="full-width">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-select
    [placeholder]="placeholder"
    [compareWith]="sameId"
    [value]="selected"
    [disabled]="disabled"
    [required]="isRequired"
    [attr.data-cy]="dataCy"
    tsMatSelectInfiniteScroll
    (selectionChange)="onSelectionChange($event.value)"
    (lastItemReached)="lastItemReached.emit()"
  >
    <mat-select-trigger>
      {{ selected?.name }}
    </mat-select-trigger>

    <ng-container *ngIf="loaded; else loadingOption">
      <ng-container *ngIf="options?.length; else noItemsOption">
        <mat-option *ngFor="let device of options" [value]="device">
          {{ device.name }}
          <small *ngIf="device.deviceType">
            {{ 'core.device_type' | translate }}: {{ device.deviceType.name }} (v.
            {{ device.deviceType.version }})
          </small>
          <small *ngIf="device.serialNumber">{{ device.serialNumber }}</small>
        </mat-option>
      </ng-container>
    </ng-container>

    <ng-template #noItemsOption>
      <mat-option disabled>{{ noItemsMessage || ('sample-form.no_devices_available' | translate) }}</mat-option>
    </ng-template>

    <ng-template #loadingOption>
      <div style="display: flex; justify-content: center; padding: 16px 0">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    </ng-template>

    <div *ngIf="hasMore" style="display: flex; justify-content: center; padding: 8px 0">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </mat-select>
  <mat-error *ngIf="hasRequiredError">{{ 'core.required' | translate }}</mat-error>
</mat-form-field>
